var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-modal--wrap"},[_c('video',{attrs:{"autoplay":"","controls":"","playsinline":"","src":_vm.link}})])}
var staticRenderFns = []

export { render, staticRenderFns }